<template>
  <v-menu
      v-model="modal"
      :close-on-click="true"
      :close-on-content-click="false"
      :return-value.sync="date"
      max-width="290px"
      min-width="290px"
      transition="scale-transition"
      offset-y
      ref="dialog"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
          v-model="date"
          :label="title"
          v-bind="attrs"
          v-on="on"
          style="width: 180px;margin: 2px"
          outlined
          clearable
          readonly
          dense
          hide-details
      ></v-text-field>
    </template>
    <v-date-picker
        v-model="date"
        type="month"
        scrollable
        locale="kor"
    />
  </v-menu>
</template>

<script>
export default {
  name: "SearchMonthPicker",
  props:{
    title :{
      type:String,
      default:'',
    }
  },
  data() {
    return{
      date: undefined,
      menu: false,
      modal: false,
    }
  },
  watch:{
    date(newValue) {
      this.$refs.dialog.save(newValue)
      const parseDate = this.$parseDate(newValue)
      const dateValue = this.title === '시작월' ?parseDate.startOf('month') :parseDate.endOf('month')
      this.$emit('input',dateValue.toJSDate())
      this.$emit('update:selected')
    }
  },


}
</script>

<style scoped>

</style>